module.exports = __webpack_public_path__ + "img/Quality Inspection_wei.4881983e.png";